/* Mexican Spanish */

export default {
  "Selected": "Seleccionado",
  "Clear": "Borrar",
  "Search": "Buscar",
  "No results found": "No se ha encontrado ningún resultado",
  'Date-range': 'Fecha-rango',
  Date: 'Fecha',
  'Add Another': 'Añadir otro',
  "Select up to": "Seleccione hasta",
  "days": "días",
  "Recent": "Recientes",
  "Search Entities": "Buscar entidades",
  "Try searching for an entity’s name, or ID. You can also search for a location.": "Pruebe buscar el nombre de una entidad o la ID. También puede buscar una ubicación.",
  "Your recent search history will be shown here the next time you use search.": "La próxima vez que haga una búsqueda su historial reciente se mostrará aquí.",
  "l": "I",
  "gal": "gal",
  "L/100KM": "L/100 KM",
  "MPG": "MPG",
  "KM/L": "KM/L",
  "kph": "k/h",
  "mph": "m/h",
  "kph/s": "km/h-s",
  "mph/s": "m/h-s",
  "m": "m",
  "ft": "ps",
  "kg": "kg",
  "lbs": "lbs",
  "°C": "°C",
  "°F": "°F",
  "square meters": "metros cuadrados",
  "square feet": "pies cuadrados",
  "square kilometers": "kilómetros cuadrados",
  "square miles": "millas cuadradas",
  "kPa": "kPa",
  "psi": "psi",
  "tonne": "tonelada",
  "ton": "tonelada",
  "km": "km",
  "mi": "mi",
  "just now": "justo ahora",
  "now": "ahora",
  "ago": "hace",
  "yesterday at": "TBD",
  "weeks": "semanas",
  "hours": "horas",
  "minutes": "minutos",
  "seconds": "TBD",
  "week": "semana",
  "day": "día",
  "hour": "hora",
  "minute": "Minuto",
  "second": "TBD",
  "wk": "TBD",
  "hr": "h",
  "min": "min",
  "sec": "seg",
  "Enter at least 2 characters to search": "Ingrese al menos 2 caracteres para buscar",
  "Keyword": "Palabra clave",
  "Show by type": "Mostrar por tipo",
  "Find": "Encontrar",
  "by": "por",
  "Try searching for": "Intente buscar",
  "Try searching by keyword.": "Intente buscar por palabra clave.",
  "No matches found": "No se encontraron coincidencias",
  "Enter atleast two characters to search": "Ingrese al menos dos caracteres para buscar",
  "Group results": "Agrupar resultados",
  "Filter for": "Filtrar por",
  "More": "Más",
  "more": "más",
  "Drag and drop images & documents": "Arrastre y suelte imágenes y documentos",
  "Upload": "Subir",
  "Upload failed": "Error al subir",
  "Uploads failed": "Subidas fallidas",
  "Uploaded files have the following issues:": "Los archivos subidos tienen los siguientes problemas:",
  "File exceeds": "El archivo excede",
  "limit": "límite",
  "is not supported. Please upload": "no es compatible. Por favor suba",
  "File is empty or corrupted.": "El archivo está vacío o corrupto.",
  "Network error": "Error de red",
  "Invalid format or size.": "Formato o tamaño inválido.",
  "Supported formats:": "Formatos compatibles:",
  "File Size:": "Tamaño del archivo:",
  "MB Max": "MB Máximo",
  "of": "de",
  "uploaded": "subido",
  "file": "archivo",
  "files": "archivos",
  "out of": "de",
  "Retry": "Reintentar",
  "Fetch Failed": "Error al cargar",
  "B": "B",
  "KB": "KB",
  "MB": "MB",
  "GB": "GB",
  "Please upload a document": "Por favor suba un documento",
  "An error occurred with this file.": "Ocurrió un error con este archivo.",
  "Item": "Elemento",
  "image": "imagen",
  "You can only upload up to": "Solo puede subir hasta",
  "and": "y",
  "or": "o",
  "Unknown format": "Formato desconocido",
  "Please enter numeric values": "Ingrese valores numericos",
  "Date format": "Formato de fecha",
  "Please select a date after": "Seleccione una fecha despues de",
  "Please select a date before": "Seleccione una fecha antes de",
  "Please select a date between": "Seleccione una fecha entre",
  "Please select a valid date": "Seleccione una fecha valida",
  "Please enter a valid date": "Ingrese una fecha valida",
  "Write something...": "Escribe algo...",
  "Esc to": "Esc para",
  "Cancel": "Cancelar",
  "Enter": "Intro",
  "to": "para",
  "Save": "Guardar",
  "Show Filters": "Mostrar filtros",
  "Hide Filters": "Ocultar filtros",
  "Show deactivated entities": "Mostrar entidades desactivadas",
  "Show deactivated": "Mostrar desactivados",
  "Deactivated": "Desactivado",
  "No data available": "No hay datos disponibles",
  "Image not available": "Imagen no disponible",
  "Video not available": "Vídeo no disponible",
  "Customize Columns": "Personalizar columnas",
  "Drag to reorder. Toggle visibility with the eye icon.": "Arrastre para reordenar. Cambie la visibilidad con el icono del ojo.",
  "Apply": "Aplicar",
  "results": "resultados",
  "Table pagination": "Paginación de la tabla",
  "Previous page": "Página anterior",
  "Next page": "Página siguiente",
  "Press < for quick navigation": "Pulse < para navegar rápidamente",
  "Press > for quick navigation": "Pulse > para navegar rápidamente",
  "Last updated:": "Última actualización:",
}
